interface SocialLink {
  href: string;
  label: string;
  icon: React.ReactNode;
}

import { Mail, Linkedin, Github } from 'lucide-react';

const SOCIAL_LINKS: SocialLink[] = [
  {
    href: 'https://www.linkedin.com/in/amandine-quellec',
    label: 'LinkedIn',
    icon: <Linkedin size={20} />,
  },
  {
    href: 'https://github.com/aquellec',
    label: 'GitHub',
    icon: <Github size={20} />,
  },
];

export const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 right-0 p-8 z-20 text-black">
      <div className="flex flex-row items-end sm:items-center gap-4">
        <a
          href="mailto:quellec.amandine@gmail.com"
          className="group flex items-center gap-2 text-sm md:text-base opacity-0 animate-fade-in"
          style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}
        >
          <Mail
            size={20}
            className="transition-transform duration-300 group-hover:-translate-y-1"
          />
          <span className="transition-all duration-300 group-hover:-translate-y-1">
            quellec.amandine@gmail.com
          </span>
        </a>
        {SOCIAL_LINKS.map(({ href, label, icon }, i) => (
          <a
            key={href}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 opacity-0 animate-fade-in"
            style={{
              animationDelay: `${1000 + i * 200}ms`,
              animationFillMode: 'forwards',
            }}
          >
            <div className="transition-transform duration-300 group-hover:-translate-y-1">
              {icon}
            </div>
            <span className="sr-only">{label}</span>
          </a>
        ))}
      </div>
    </footer>
  );
};
